import { useState, useEffect, useCallback, useRef } from "react"
import { useHistory } from 'react-router-dom';
import { useParams } from "react-router"

import { Card, CardContent } from "@material-ui/core"
import CachedIcon from '@material-ui/icons/Cached'
import IconButton from '@material-ui/core/IconButton'
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from '@material-ui/core/Tooltip'
import Zoom from '@material-ui/core/Zoom'
import Table from '@base/Table'
import Toast from '@base/Toast'
import {
  verifyPagingAndSorting,
	PAGE,
	SIZE,
	DESC,
	TOTAL_ELEMENTS,
	TOTAL_PAGES,
} from '@base/Table/Utils'

import AuthorizedFunction from '@security/AuthorizedFunction'

import RelatorioService from "@services/RelatorioService"

import { ProcessoResolver } from "@helpers/ProcessoHelper"
import { removePagingAndSorting } from '@helpers/PaginationHelper'

export const Acompanhamento = () => {
	const [loading, setLoading] = useState(true);
	const [loadingGeral, setLoadingGeral] = useState(true);
	const [loadingControles, setLoadingControles] = useState(true);
	const [loadingObmep, setLoadingObmep] = useState(true);

	const [listQuantitativoGeral, setListQuantitativoGeral] = useState([]);
	const [listQuantitativoTransferidoObmep, setListQuantitativoTransferidoObmep] = useState([]);
	const [listControles, setListControles] = useState([]);
	const [listQuantitativoPorData, setListQuantitativoPorData] = useState([]);

	const [filtroAtivo, setFiltroAtivo] = useState(false);

	const [page, setPage] = useState(PAGE);
	const [size, setSize] = useState(SIZE);
	const [defaultOrderBy,] = useState('data')
	const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: DESC }]);
	const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
	const [totalPages, setTotalPages] = useState(TOTAL_PAGES);
	const history = useHistory();
	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const toastRef = useRef(null);

	const columnsQuantitativoGeral = [
		{ label: 'Envelopes Recebidos', name: 'envelopesRecebidos', func: null, key: false, ordering: false },
		{ label: 'Escolas - Correios', name: 'escolasCorreios', func: null, key: false, ordering: false },
		{ label: 'Escolas - App', name: 'escolasApp', func: null, key: false, ordering: false },
    { label: 'Escolas - IMPA', name: 'escolasIMPA', func: null, key: false, ordering: false },


		{ label: 'Total de Escolas (Inclusive as com mais de uma envelope)', name: 'totalEscolas', func: null, key: true, ordering: false },
		{ label: 'Cartões Contados', name: 'cartoesPistolados', func: null, key: false, ordering: false },
		{ label: 'Cartões Digitalizados', name: 'cartoesDigitalizados', func: null, key: false, ordering: false },
		{ label: 'Cartões Descartados', name: 'cartoesDescartados', func: null, key: false, ordering: false },
		{ label: 'Cartões Válidos', name: 'cartoesValidos', func: null, key: false, ordering: false },
		{ label: 'Cartões Válidos Digitação de Texto (Concluida/Aguardando)', name: 'cartoesDigitados', func:  (c, l) => { return <>{l.cartoesDigitados} / {l.cartoesFaltandoDigitacao}</> }, key: false, ordering: false },
		{ label: 'Cartões Válidos OCR (Concluida/Aguardando)', name: 'cartoesTeleform', func:  (c, l) => { return <>{l.cartoesTeleform} / {l.cartoesFaltandoLerBolinhas}</> }, key: false, ordering: false },

		{ label: 'DE\'s Digitalizados', name: 'deDigitalizados', func: null, key: false, ordering: false },
		{ label: 'DE\'s Digitacao', name: 'deDigitacao', func: null, key: false, ordering: false },

	];

	const columnsControles = [
		{ label: '', name: 'descricao', func: null, key: true, ordering: false },
		{ label: '', name: 'ok', func: (c,l) => {
			return c ? <CheckIcon/> : (l.url ? <>
								<span style={{cursor: 'pointer', textDecoration: 'underline'}}
									   onClick={() => redirecionarParaPagina(l.url)}>Visualizar Pendências</span></> : "")
		}, key: false, ordering: false },
	];

	const columnsQuantitativoTransferidoObmep = [
		{ label: 'Escolas', name: 'totalEscolas', func: null, key: true, ordering: false },
		{ label: 'Cartões Nível 1', name: 'totalCartoesN1', func: null, key: false, ordering: false },
		{ label: 'Cartões Nível 2', name: 'totalCartoesN2', func: null, key: false, ordering: false },
		{ label: 'Cartões Nível 3', name: 'totalCartoesN3', func: null, key: false, ordering: false },
	];

	const columnsQuantitativoPorData = [
		{ label: 'Data', name: 'data', func: null, key: true }];

		if((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) ){
			columnsQuantitativoPorData.push({ label: 'Envelopes Recebidos', name: 'envelopesRecebidos', func: null, key: false, ordering: false });
			columnsQuantitativoPorData.push({ label: 'Escolas - Correios', name: 'escolasCorreios', func: null, key: false, ordering: false });
			columnsQuantitativoPorData.push({ label: 'Escolas - App', name: 'escolasApp', func: null, key: false, ordering: false });
			columnsQuantitativoPorData.push({ label: 'Total de Escolas', name: 'totalEscolas', func: null, key: false, ordering: false });
			

		}

		columnsQuantitativoPorData.push({ label: 'Cartões Digitalizados', name: 'cartoesDigitalizados', func: null, key: false, ordering: false });
		columnsQuantitativoPorData.push({ label: 'Cartões Contados', name: 'cartoesPistolados', func: (c,l) => l.cartoesPistolados == null ? "0" : c, key: false, ordering: false },);
		columnsQuantitativoPorData.push({ label: 'Cartões OCR', name: 'cartoesTeleform', func: null, key: false, ordering: false });
		columnsQuantitativoPorData.push(	{ label: 'Cartões Digitados', name: 'cartoesDigitados', func: null, key: false, ordering: false })
		columnsQuantitativoPorData.push({ label: 'Cartões Descartados', name: 'cartoesDescartados', func: (c,l) => l.cartoesDescartados == null ? "0" : c, key: false, ordering: false },);

		if((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) ){
			columnsQuantitativoPorData.push({ label: 'DE\'s Digitalizados', name: 'deDigitalizados', func: null, key: false, ordering: false });
		}

		if((AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) ){
			
			columnsQuantitativoPorData.push({ label: 'DE\'s Digitados', name: 'deDigitacao', func: null, key: false, ordering: false });
		}
	
	function redirecionarParaPagina(pagina) {
		history.push(`${pagina}`);
	  }
	
	

	const handlePage = page => { setPage(page); setFiltroAtivo(true); };
	const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };
	const handleSort = (orderBy, order) => {
		if (sort.find(s => s.orderBy === orderBy)) {
			let newSort = sort.filter(s => s.orderBy !== orderBy);
			newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
			setSort([...newSort]);
		} else {
			setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
		}
		setFiltroAtivo(true);
	}
	const handleClearSort = (orderBy) => { setFiltroAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: DESC }]) };
	const handleTotalPages = () => totalPages;
	const handleTotalElements = () => totalElements;

  const buscarQuantitativoGeral = useCallback((forceRefresh = false) => {
    setLoadingGeral(true);
    const filters = [{ 'field': "forceRefresh", 'value': forceRefresh }];

    RelatorioService.quantitativoGeral(processo.id, filters).then(resultado => {
      setListQuantitativoGeral(resultado.data);
      setLoadingGeral(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Carregar as Informações de Quantitativo Geral."));
  },[processo])

  const buscarControles = useCallback((forceRefresh = false) => {
    setLoadingControles(true);
    const filters = [{ 'field': "forceRefresh", 'value': forceRefresh }];

    RelatorioService.controles(processo.id, filters).then(resultado => {
      setListControles(resultado.data);
      setLoadingControles(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Carregar os Controles."));
  },[processo])

  const buscarQuantitativosTransferidoOBMEP = useCallback((forceRefresh = false) => {
    setLoadingObmep(true);
    const filters = [{ 'field': "forceRefresh", 'value': forceRefresh }];

    RelatorioService.quantitativoTransferidoObmep(processo.id, filters).then(resultado => {
      setListQuantitativoTransferidoObmep(resultado.data);
      setLoadingObmep(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Carregar as Informações de Quantitativo Transferidos para OBMEP."));
  },[processo])

  const buscarQuantitativoPorData = useCallback((forceRefresh = false) => {
    setLoading(true);
    const f = verifyPagingAndSorting(removePagingAndSorting([]), page, size, sort, filtroAtivo);

    const filters = f.filter(filter => filter.field !== "forceRefresh");
    filters.push({ 'field': "forceRefresh", 'value': forceRefresh });

    RelatorioService.quantitativoPorData(processo.id, filters).then(resultado => {
      const { content, number, size, totalElements, totalPages } = resultado.data;
      setListQuantitativoPorData(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Carregar as Informações de Quantitativo por Data."));
  },[processo, page, size, sort, filtroAtivo]);

  	const carregarDados = useCallback(() => {
		if (processo.id) {
			if(listQuantitativoGeral.length === 0)
        		buscarQuantitativoGeral();

			if(listQuantitativoTransferidoObmep.length === 0)
        		buscarQuantitativosTransferidoOBMEP();

			buscarQuantitativoPorData();
			buscarControles();

		}
	}, [processo,
		listQuantitativoGeral,
		buscarQuantitativoGeral,
		listQuantitativoTransferidoObmep, 
		buscarQuantitativosTransferidoOBMEP,
		buscarQuantitativoPorData, 
		buscarControles
	]);

	useEffect(() => carregarDados(), [carregarDados]);

	const acompanhamentosView = () => {
		return <>


{(AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) &&
          <Card style={{marginTop:10}}>
            <CardContent style={{ padding:10, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
              Verificações
              <Tooltip title={"Atualizar"} TransitionComponent={Zoom}>
                <IconButton size="small" component="div" color={"default"} onClick={() => buscarControles(true)} >
                  <CachedIcon />
                </IconButton>
              </Tooltip>
            </CardContent>
            <CardContent>
              <Table style={{marginTop:5}}
              columns={columnsControles}
              tableData={listControles}
              actions={[]}
              page={null}
              rowsPerPage={null}
              loading={loadingControles}
            />
            </CardContent>
          </Card>
        }

			{(AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) &&
          <Card style={{marginTop:10}}>
            <CardContent style={{ padding:10, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
              Geral
              <Tooltip title={"Atualizar"} TransitionComponent={Zoom}>
                <IconButton size="small" component="div" color={"default"} onClick={() => buscarQuantitativoGeral(true)} >
                  <CachedIcon />
                </IconButton>
              </Tooltip>
            </CardContent>
            <CardContent>
              <Table style={{marginTop:5}}
              columns={columnsQuantitativoGeral}
              tableData={listQuantitativoGeral}
              actions={[]}
              page={null}
              rowsPerPage={null}
              loading={loadingGeral}
            />
            </CardContent>
          </Card>
        }

				{(AuthorizedFunction(["__processo.usuario.central"]) || AuthorizedFunction(["__processo.usuario.operador"])) &&
          <Card style={{marginTop:10}}>
            <CardContent style={{ padding:10, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
              Transferíveis para OBMEP
              <Tooltip title={"Atualizar"} TransitionComponent={Zoom}>
                <IconButton size="small" component="div" color={"default"} onClick={() => buscarQuantitativosTransferidoOBMEP(true)} >
                  <CachedIcon />
                </IconButton>
              </Tooltip>
            </CardContent>
            <CardContent>
              <Table style={{marginTop:5}}
              columns={columnsQuantitativoTransferidoObmep}
              tableData={listQuantitativoTransferidoObmep}
              actions={[]}
              page={null}
              rowsPerPage={null}
              loading={loadingObmep}
            />
            </CardContent>
          </Card>
        }

				<Card style={{marginTop:10}}>
					<CardContent style={{padding:10, fontSize: 14, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>
            Por Data
            <Tooltip title={"Atualizar"} TransitionComponent={Zoom}>
              <IconButton size="small" component="div" color={"default"} onClick={() => buscarQuantitativoPorData(true)} >
                <CachedIcon />
              </IconButton>
            </Tooltip>
          </CardContent>
					<CardContent style={{padding:0,paddingLeft:15,paddingRight:15}}>
						<Table style={{marginTop:5}}
						columns={columnsQuantitativoPorData}
						tableData={listQuantitativoPorData}
						actions={[]}
						page={page}
						handlePage={handlePage}
						handleTotalPages={handleTotalPages}
						handleTotalElements={handleTotalElements}
						rowsPerPage={size}
						handleRowsPerPage={handleRowsPerPage}
						sort={sort}
						handleSort={handleSort}
						handleClearSort={handleClearSort}
						loading={loading}
					/>
					</CardContent>
				</Card>
		</>
	}

	return (
		<>
			<Toast ref={toastRef} />
			{acompanhamentosView()}
		</>
	);
}

export default Acompanhamento;
